// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel } from '../project-navigation.model';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { ProServeProjectNavigationService } from '../service/pro-serve-project-navigation.service';
import { UserSettings } from '@user/model/user-settings';

@Component({
  standalone: false,
  templateUrl: './import-proserve.component.html',
  selector: 'app-import-proserve'
})
export class ImportProserveComponent implements OnInit {
  @Input() document: Document;

  @Output() public finish = new EventEmitter<void>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  public constructor(
    private projectNavigationService: ProjectNavigationService,
    private proServeProjectNavigationService: ProServeProjectNavigationService,
    private userSettings: UserSettings
  ) {}

  public ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.currentModel = {
      importType: null,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      visibleSharedProjects: false
    }

    this.projectNavigationService.openPreselectedProjectGroup(this.model);
  }

  public updateSubmitEnabled() {
    this.submitEnabled = this.isActionButtonEnabledImportMode();
  }

  private isActionButtonEnabledImportMode(): boolean {
    const currentProjectGroup: ProjectGroupVO = this.model.currentProjectFolder;
    if (!currentProjectGroup) {
      return false;
    }
    return true;
  }

  public cancel() {
    this.finish.emit();
  }

  public async importProserve() {
    this.finish.emit();
    await this.proServeProjectNavigationService.startImportProServeProcess(this.model.currentProjectFolder, this.document);
  }
}
